// PDF styles matching MUI theme
export const COLORS = {
  primary: {
    main: "#186480",
    light: "#bad1d9",
    dark: "#0e3c4d",
  },
  secondary: {
    main: "#E0801E",
    light: "#f6d9bc",
    dark: "#5a330c",
  },
  text: {
    primary: "#1a1a1a",
    secondary: "#666666",
    light: "#ffffff",
  },
  background: {
    paper: "#ffffff",
    default: "#f0f0f0",
  },
  status: {
    pending: "#ffa726",
    accepted: "#66bb6a",
    rejected: "#ef5350",
    modified: "#42a5f5",
  },
  risk: {
    1: "#4caf50", // Very Low - Green
    2: "#8bc34a", // Low - Light Green
    3: "#ffeb3b", // Medium - Yellow
    4: "#ff9800", // High - Orange
    5: "#f44336", // Very High - Red
  },
};

export const FONTS = {
  title: 18,
  subtitle: 14,
  heading: 12,
  body: 10,
  small: 8,
};

export const MARGINS = {
  page: 20,
  section: 15,
  element: 10,
};

export const TABLE_STYLES = {
  header: {
    fillColor: COLORS.primary.main,
    textColor: COLORS.text.light,
    fontSize: FONTS.body,
    fontStyle: "bold",
    halign: "left",
  },
  body: {
    fillColor: COLORS.background.paper,
    textColor: COLORS.text.primary,
    fontSize: FONTS.small,
  },
  alternateRow: {
    fillColor: COLORS.background.default,
  },
};

export const getRiskColor = (riskLevel) => {
  return COLORS.risk[riskLevel] || COLORS.text.secondary;
};

export const getRiskLabel = (riskLevel) => {
  const labels = {
    1: "Very Low",
    2: "Low",
    3: "Medium",
    4: "High",
    5: "Very High",
  };
  return labels[riskLevel] || "Unknown";
};

export const getStatusColor = (status) => {
  const statusLower = status?.toLowerCase();
  return COLORS.status[statusLower] || COLORS.text.secondary;
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
